const CATEGORIES = {
  CLEANSER: 'Cleanser',
  EXFOLIATOR: 'Exfoliator',
  MASK: 'Mask',
  TONER: 'Toner',
  SERUM: 'Serum',
  EYE_TREATMENT: 'Eye Treatment',
  MOISTURIZER: 'Moisturizer',
  SPF: 'SPF',
  PRIMER: 'Primer',
  MIST: 'Mist',
  BODY: 'Body',
  BRONZER: 'Bronzer',
};

export default CATEGORIES;
